import { InjectionToken } from "@angular/core";
import { ClientEnvironment } from "./client-environment.interface";

/**
 * @const ENVIRONMENT
 * Injection token for the environment interface to be provided by the applications.
 */
 export const ENVIRONMENT = new InjectionToken<ClientEnvironment>('ENVIRONMENT');
 